<template>
  <div class="newcare-cta">
    <div class="cta-content">
      <h4>{{ title || 'Ready to Automate These Savings?' }}</h4>
      <p>{{ message || 'See how Newcare\'s cashless solution can help you achieve these results with zero transaction fees and seamless integration.' }}</p>
      <a :href="newcareUrl" target="_blank" rel="noopener noreferrer" class="cta-button">
        {{ buttonText || 'Explore Newcare Solutions' }}
        <span class="external-link-icon">↗</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewcareCTA',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    newcareUrl: {
      type: String,
      default: 'https://www.newcare.io'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.newcare-cta {
  background: lighten($body-bg, 8%);
  border: 2px solid $primary;
  border-radius: 0.75rem;
  padding: 2rem;
  margin: 2rem 0;
  text-align: center;

  .cta-content {
    max-width: 600px;
    margin: 0 auto;

    h4 {
      font-size: 1.5rem;
      font-weight: 700;
      color: $body-color;
      margin-bottom: 1rem;
    }

    p {
      font-size: 1.1rem;
      color: rgba($body-color, 0.9);
      margin-bottom: 1.5rem;
      line-height: 1.6;
    }

    .cta-button {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      padding: 1rem 2rem;
      background: $primary;
      color: $body-bg;
      border-radius: 0.5rem;
      font-size: 1.125rem;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.3s ease;
      border: 2px solid $primary;

      &:hover {
        background: lighten($primary, 10%);
        border-color: lighten($primary, 10%);
        color: $body-bg;
        text-decoration: none;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba($primary, 0.3);
      }

      .external-link-icon {
        font-size: 1rem;
        opacity: 0.8;
      }
    }
  }
}

@media (max-width: 768px) {
  .newcare-cta {
    padding: 1.5rem;

    .cta-content {
      h4 {
        font-size: 1.25rem;
      }

      p {
        font-size: 1rem;
      }

      .cta-button {
        font-size: 1rem;
        padding: 0.875rem 1.5rem;
      }
    }
  }
}
</style>
